import React from "react";
import { useLang } from "@/i18n/LanguageContext";
import { Mail, Phone, MapPin, Linkedin, Instagram } from "lucide-react";

const WHATS_URL = (msg) =>
  `https://api.whatsapp.com/send?phone=554599744439&text=${encodeURIComponent(msg)}`;

export default function Footer() {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="pt-20 pb-10"
      style={{ background: "#081b34", color: "#e5e7eb" }}
    >
      <div className="sap-container">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <img
              src="/logo-sapientia-dark.png"
              alt="Sapientia Consultores Associados"
              className="h-12 w-auto object-contain"
              draggable={false}
            />
            <p className="mt-6 text-sm leading-relaxed text-white/70 max-w-md">
              {t.footer.tagline}
            </p>

            <div className="mt-8 flex gap-3">
              <a
                aria-label="LinkedIn"
                data-testid="footer-linkedin"
                href="https://www.linkedin.com/company/sapientia-consultores-associados-ltda/?viewAsMember=true"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-10 h-10 border border-white/20 hover:border-[color:var(--sap-gold)] hover:text-[color:var(--sap-gold)] transition-colors"
              >
                <Linkedin size={16} strokeWidth={1.5} />
              </a>
              <a
                aria-label="Instagram"
                data-testid="footer-instagram"
                href="https://www.instagram.com/sapientiaarquitetandoagestao"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center w-10 h-10 border border-white/20 hover:border-[color:var(--sap-gold)] hover:text-[color:var(--sap-gold)] transition-colors"
              >
                <Instagram size={16} strokeWidth={1.5} />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-[11px] uppercase tracking-[0.28em] text-[color:var(--sap-gold)] mb-5">
              {t.footer.nav_title}
            </h4>
            <ul className="space-y-3 text-sm text-white/75">
              <li>
                <a href="#manifesto" className="hover:text-white transition-colors">
                  {t.nav.about}
                </a>
              </li>
              <li>
                <a href="#architecture" className="hover:text-white transition-colors">
                  {t.nav.architecture}
                </a>
              </li>
              <li>
                <a href="#services" className="hover:text-white transition-colors">
                  {t.nav.services}
                </a>
              </li>
              <li>
                <a href="#process" className="hover:text-white transition-colors">
                  {t.nav.process}
                </a>
              </li>
              <li>
                <a href="#technology" className="hover:text-white transition-colors">
                  {t.nav.technology}
                </a>
              </li>
              <li>
                <a href="#diagnostic" className="hover:text-white transition-colors">
                  {t.nav.diagnostic}
                </a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="text-[11px] uppercase tracking-[0.28em] text-[color:var(--sap-gold)] mb-5">
              {t.footer.contact_title}
            </h4>

            <div className="flex flex-wrap gap-3 mb-6">
              <a
                href={WHATS_URL(t.whatsapp_msg)}
                data-testid="footer-whatsapp"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="WhatsApp"
                className="inline-flex items-center gap-2 px-4 py-2.5 border border-white/25 text-white text-[11px] uppercase tracking-[0.22em] hover:border-[color:var(--sap-gold)] hover:text-[color:var(--sap-gold)] transition-colors"
                style={{ borderRadius: 2 }}
              >
                <Phone size={14} strokeWidth={1.75} />
                WhatsApp
              </a>
              <a
                href="mailto:luiz.junior.sapientia@gmail.com"
                data-testid="footer-email"
                aria-label="E-mail"
                className="inline-flex items-center gap-2 px-4 py-2.5 border border-white/25 text-white text-[11px] uppercase tracking-[0.22em] hover:border-[color:var(--sap-gold)] hover:text-[color:var(--sap-gold)] transition-colors"
                style={{ borderRadius: 2 }}
              >
                <Mail size={14} strokeWidth={1.75} />
                E-mail
              </a>
            </div>

            <div className="flex items-start gap-3 text-sm text-white/70">
              <MapPin size={16} strokeWidth={1.5} className="mt-0.5 shrink-0" />
              <span>{t.footer.address}</span>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <p className="text-xs text-white/50">
            {t.footer.copyright.replace("{year}", year)}
          </p>
          <div className="flex gap-6 text-xs text-white/50">
            <a href="#" className="hover:text-white/80 transition-colors">
              {t.footer.privacy}
            </a>
            <a href="#" className="hover:text-white/80 transition-colors">
              {t.footer.terms}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
